import { render, staticRenderFns } from "./ComboMeals.vue?vue&type=template&id=72b0a09a"
import script from "./ComboMeals.vue?vue&type=script&lang=ts"
export * from "./ComboMeals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports